module.exports = __webpack_public_path__ + "static/media/squamish-6.62813599.jpg";